// Default widget layouts per role/type combination
// Widgets with md=6 in the registry will sit side-by-side when adjacent

const dirigeantLayout = [
  { widgetId: "kpi-cards", position: 0, visible: true },
  { widgetId: "repair-rates", position: 1, visible: true },
  // { widgetId: "satisfaction", position: 2, visible: true },
  // { widgetId: "rendement", position: 2, visible: true },
  // CA (md=6) + Missions (md=6) sit side by side
  { widgetId: "ca", position: 3, visible: true },
  { widgetId: "missions", position: 4, visible: true },
  // { widgetId: "podiums", position: 5, visible: true },
  // Alerts (md=6) + Quick Actions (md=6) sit side by side
  // { widgetId: "alerts", position: 6, visible: true },
  // { widgetId: "quick-actions", position: 7, visible: true },
  // { widgetId: "team-overview", position: 8, visible: false },
];

const responsableTechniqueLayout = [
  { widgetId: "kpi-cards", position: 0, visible: true },
  { widgetId: "repair-rates", position: 1, visible: true },
  // { widgetId: "satisfaction", position: 1, visible: true },
  // // Interview progress (md=6) + Alerts (md=6)
  // { widgetId: "interview-progress", position: 2, visible: true },
  // { widgetId: "alerts", position: 3, visible: true },
  // { widgetId: "podiums", position: 4, visible: true },
  // { widgetId: "rendement", position: 5, visible: true },
  // { widgetId: "quick-actions", position: 6, visible: true },
  // { widgetId: "team-overview", position: 7, visible: false },
];

const responsableAdminLayout = [
  { widgetId: "kpi-cards", position: 0, visible: true },
  { widgetId: "repair-rates", position: 1, visible: true },
  // Interview progress (md=6) + Quick Actions (md=6)
  // { widgetId: "interview-progress", position: 1, visible: true },
  // { widgetId: "quick-actions", position: 2, visible: true },
  // { widgetId: "satisfaction", position: 3, visible: true },
  // { widgetId: "rendement", position: 4, visible: true },
  // { widgetId: "team-overview", position: 5, visible: false },
];

const drhLayout = [
  { widgetId: "kpi-cards", position: 0, visible: true },
  { widgetId: "repair-rates", position: 1, visible: true },
  // // Interview progress (md=6) + Quick Actions/other (md=6)
  // { widgetId: "interview-progress", position: 1, visible: true },
  // { widgetId: "satisfaction", position: 2, visible: true },
  // { widgetId: "rendement", position: 3, visible: true },
  // { widgetId: "team-overview", position: 4, visible: false },
];

const expertLayout = [
  { widgetId: "kpi-cards", position: 0, visible: true },
  { widgetId: "repair-rates", position: 1, visible: true },
  // { widgetId: "personal-perf", position: 1, visible: true },
  // { widgetId: "satisfaction", position: 2, visible: true },
  // { widgetId: "quick-actions", position: 3, visible: true },
  // { widgetId: "interview-progress", position: 4, visible: true },
];

const assistantLayout = [
  { widgetId: "kpi-cards", position: 0, visible: true },
  { widgetId: "repair-rates", position: 1, visible: true },
  // Interview progress (md=6) + Quick Actions (md=6)
  // { widgetId: "interview-progress", position: 1, visible: true },
  // { widgetId: "quick-actions", position: 2, visible: true },
];

export const getDefaultLayout = (type, role) => {
  const t = Number(type);
  const r = Number(role);
  if (r === 4) return dirigeantLayout;
  if (r === 3) return drhLayout;
  if (r === 1) return responsableTechniqueLayout;
  if (r === 2) return responsableAdminLayout;
  if ([0, 1, 2].includes(t) && r === 0) return expertLayout;
  if ([3, 4, 5].includes(t) && r === 0) return assistantLayout;
  return assistantLayout;
};
